import React from "react";
import ReactDOM from "react-dom";

const tagScript = (w, d, s, l, i) => {
  w[l] = w[l] || [];
  w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const [f] = d.getElementsByTagName(s),
    j = d.createElement(s),
    dl = l !== "dataLayer" ? "&l=" + l : "";
  j.async = true;
  j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  f.parentNode.insertBefore(j, f);
};

const GTM_ID = "GTM-MN294G5";

export default ({ enabled }) => {
  if (!enabled) {
    return <React.Fragment />;
  }
  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <script>
          {tagScript(window, document, "script", "dataLayer", GTM_ID)}
        </script>,
        document.head
      )}
      {ReactDOM.createPortal(
        <noscript>
          <iframe
            title="gtm"
            src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidde" }}
          ></iframe>
        </noscript>,
        document.body
      )}
    </React.Fragment>
  );
};
